import { usePathname, useSearchParams } from "next/navigation";

export function useCreateSignInRedirectURL() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const redirectUrl = pathname !== "/" ? `${pathname}${searchParams ? "?" + searchParams.toString() : ""}` : "";
  const signInUrl = redirectUrl ? `/sign-in?redirect_url=${encodeURIComponent(redirectUrl)}` : "/sign-in";

  return signInUrl;
}
